import { Button, Stack, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import { zodResolver } from '@hookform/resolvers/zod'
import {
  ContactFormScheme,
  contactFormScheme,
} from './_scheme/contactForm.scheme'
import { Form, useForm } from 'react-hook-form'
import { FormStyledTextField } from '~/@ui/form/FormStyledTextField'
import { getApi } from '~/@utils/api/getApi'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'
import { useAlert } from '~/@ui/alert/useAlert'

export const ContactFormPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const { showAlert } = useAlert()

  const isInvestorRoute = location.pathname.includes('/investor/')

  const helpCenterPath = isInvestorRoute
    ? '/investor/help-center'
    : '/vlastnik/help-center'

  const { control, getValues, trigger } = useForm<ContactFormScheme>({
    resolver: zodResolver(contactFormScheme),
    mode: 'onTouched',
    defaultValues: {
      subject: '',
      body: '',
    },
  })

  const sendMessageToSupport = async () => {
    const subject = getValues('subject')
    const body = getValues('body')

    try {
      const { data: response } =
        await getApi().supportTicketsAppApiControllerCreateSupportTicket({
          type: 'text',
          subject: subject,
          message: body,
        })

      if ('success' in response) {
        showAlert('success', 'Kontaktný formulár bol úspešne odoslaný.')
        navigate(helpCenterPath)
        return
      }

      throw new Error(
        'Nasatala neznáma chyba pri odosielaní kontaktného formulára.'
      )
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    }
  }

  const handleSubmit = async () => {
    const isValid = await trigger()

    if (!isValid) {
      showAlert(
        'error',
        'Predmet nemôže byť prádny a správa musí obsahovať aspoň 10 znakov.'
      )
      return
    }

    sendMessageToSupport()
  }

  return (
    <Stack className="w-screen min-h-screen">
      <Stack className="flex-row h-[70px] items-center gap-3 px-6 py-6">
        <ArrowBackIosNewOutlinedIcon
          className="mb-1 cursor-pointer"
          onClick={() => navigate(helpCenterPath)}
        />
        <Stack className="">
          <Typography className="text-base font-semibold text-zBlack200 ">
            Kontaktný formulár
          </Typography>
          <Typography className="text-xs font-medium text-zGrey400">
            Centrum pomoci
          </Typography>
        </Stack>
      </Stack>

      <Stack
        className="w-full max-w-[768px] self-center p-6 rounded-t-4d bg-zBlack200"
        sx={{ minHeight: 'calc(100vh - 70px)' }}>
        <Typography className="text-base font-bold text-zWhite200">
          Kontaktný formulár
        </Typography>

        <Stack className="items-center py-8">
          <Form control={control} className="flex flex-col w-full gap-3 pb-3">
            <FormStyledTextField
              control={control}
              name="subject"
              placeholder="Predmet"
              darkTheme
            />
            <FormStyledTextField
              control={control}
              multiline
              name="body"
              placeholder="Správa"
              rows={2}
              darkTheme
            />
            <Button
              variant="contained"
              className="
                w-fit h-14 px-5 mt-[52px] bg-zWhite200 self-center
                text-3d font-medium text-zBlack200
              "
              type="button"
              onClick={handleSubmit}>
              Kontaktovať podporu
            </Button>
          </Form>
        </Stack>
      </Stack>
    </Stack>
  )
}
